var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.501,
    r: 6.667,
    fill: "#A4B2CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.167a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333Zm-1.042-4.583h.625V8.917h-.625a.623.623 0 0 1-.625-.625c0-.346.279-.625.625-.625h1.25c.347 0 .625.279.625.625v2.292h.209c.346 0 .625.279.625.625a.624.624 0 0 1-.625.625H7.458a.624.624 0 0 1-.625-.625c0-.346.279-.625.625-.625ZM8.5 5.167a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667Z",
    fill: "#DCE3F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeIcon);
export default __webpack_public_path__ + "static/media/notice-icon.e730b073d3d88571d20f621b41c50cb4.svg";
export { ForwardRef as ReactComponent };